import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  GET_DOCUMENT_LIST_TKT_RESULT_STORE_NAME,
  GetDocumentListTktResultState,
} from './get-document-list-tkt-result.state';

/** Select GetDocumentListTktResult State */
export const selectGetDocumentListTktResultState = createFeatureSelector<GetDocumentListTktResultState>(
  GET_DOCUMENT_LIST_TKT_RESULT_STORE_NAME
);

/** Select GetDocumentListTktResult isPending status */
export const selectGetDocumentListTktResultIsPendingStatus = createSelector(
  selectGetDocumentListTktResultState,
  (state) => !!state.isPending
);

/** Select GetDocumentListTktResult isFailure status */
export const selectGetDocumentListTktResultIsFailureStatus = createSelector(
  selectGetDocumentListTktResultState,
  (state) => !!state.isFailure
);
